import BaseProvider from './BaseProvider';

export default class Msa extends BaseProvider {
  constructor(config: BaseProvider['config']) {
    super(config);
  }

  loadScript(onLoaded?: any, onError?: any) {
    if ((window as any).Msal) {
      onLoaded?.();
      return;
    }
    const appendAlternativeScript = () => {
      const newScript = document.createElement('script');
      newScript.src = 'https://alcdn.msftauth.net/lib/1.2.1/js/msal.js';
      newScript.integrity =
        'sha384-m/3NDUcz4krpIIiHgpeO0O8uxSghb+lfBTngquAo2Zuy2fEF+YgFeP08PWFo5FiJ';
      newScript.crossOrigin = 'anonymous';
      newScript.defer = true;
      newScript.onload = () => {
        this.isLoaded = true;
        onLoaded?.();
      };
      newScript.onerror = onError;
      document.head.appendChild(newScript);
    };
    const alcdnScript = document.createElement('script');
    alcdnScript.src = 'https://alcdn.msauth.net/lib/1.2.1/js/msal.js';
    alcdnScript.integrity =
      'sha384-9TV1245fz+BaI+VvCjMYL0YDMElLBwNS84v3mY57pXNOt6xcUYch2QLImaTahcOP';
    alcdnScript.crossOrigin = 'anonymous';
    alcdnScript.defer = true;
    alcdnScript.onload = () => {
      this.isLoaded = true;
      onLoaded?.();
    };
    alcdnScript.onerror = appendAlternativeScript;
    document.head.appendChild(alcdnScript);
  }

  logout() {
    const {
      clientId,
      authority,
      postLogoutRedirectUri,
      redirectUri,
      mode = 'popup',
    } = this.config;
    if (!this.isLoaded) {
      return;
    }
    const config = {
      auth: {
        clientId,
        authority,
        postLogoutRedirectUri,
        redirectUri,
      },
    };
    const myMsal = new (window as any).Msal.UserAgentApplication(config);

    if (mode === 'popup') {
      const logoutRequest = {
        account: myMsal.getAccountByHomeId(this.account.accountId),
        mainWindowRedirectUri: postLogoutRedirectUri,
      };

      myMsal.logoutPopup(logoutRequest);
    } else {
      myMsal.logout();
    }
  }

  login() {
    const {
      clientId,
      authority,
      postLogoutRedirectUri,
      redirectUri,
      scopes = ['user.read'],
      mode = 'popup',
    } = this.config;
    if (!this.isLoaded) {
      return;
    }
    const config = {
      auth: {
        clientId,
        authority,
        postLogoutRedirectUri,
        redirectUri,
      },
    };

    console.log('config', config)
    
    const myMsal = new (window as any).Msal.UserAgentApplication(config);
    if (mode === 'popup') {
      myMsal
        .loginPopup({ scopes })
        .then((loginResponse: any) => {
          this.account = loginResponse?.account;
          window.location.href = redirectUri;
        })
        .catch(this?.onError);
    } else {
      const authCallback = (error: any, response: any) => {
        if (response) {
          this.account = response.account;
          // Display signed-in user content, call API, etc.
        } else {
          // In case multiple accounts exist, you can select
          this?.onError?.(error);
        }
      };

      myMsal.handleRedirectCallback(authCallback);
      myMsal.loginRedirect({ scopes });
    }
  }

  acquireToken(): Promise<string> {
    return new Promise<string>((resolve) => {
      const {
        clientId,
        authority,
        postLogoutRedirectUri,
        redirectUri,
        scopes = ['user.read'],
        mode = 'popup',
      } = this.config;
      if (!this.isLoaded) {
        return undefined;
      }
      const config = {
        auth: {
          clientId,
          authority,
          postLogoutRedirectUri,
          redirectUri,
        },
      };
      const userAgentApplication = new (
        window as any
      ).Msal.UserAgentApplication(config);

      const account = this.account || userAgentApplication.getAllAccounts()[0];

      const accessTokenRequest = {
        scopes,
        account: account,
      };
      if (mode === 'popup') {
        return userAgentApplication
          .acquireTokenSilent(accessTokenRequest)
          .then(function (accessTokenResponse: any) {
            // Acquire token silent success
            resolve(accessTokenResponse.accessToken);
            // Call your API with token
            //   callApi(accessToken);
          })
          .catch(function (error: any) {
            //Acquire token silent failure, and send an interactive request
            if (error?.errorMessage?.indexOf?.('interaction_required') !== -1) {
              return userAgentApplication
                .acquireTokenPopup(accessTokenRequest)
                .then(function (accessTokenResponse: any) {
                  // Acquire token interactive success
                  resolve(accessTokenResponse.accessToken);
                  // Call your API with token
                })
                .catch(function () {
                  // Acquire token interactive failure
                  resolve('');
                });
            }
          });
      } else {
        const authCallback = (_error: any, _response: any) => {
          if (_error) {
            resolve('');
          } else {
            accessTokenRequest.account = _response?.account;
            userAgentApplication
              .acquireTokenSilent(accessTokenRequest)
              .then(function (accessTokenResponse: any) {
                resolve(accessTokenResponse.accessToken);
              })
              .catch(function (error: any) {
                if (
                  error &&
                  error?.errorMessage?.indexOf('interaction_required') !== -1
                ) {
                  userAgentApplication.acquireTokenRedirect(accessTokenRequest);
                } else {
                  resolve('');
                }
              });
          }
        };

        userAgentApplication.handleRedirectCallback(authCallback);
      }
    });
  }

  isAuthenticated(): boolean {
    const { clientId, authority, postLogoutRedirectUri, redirectUri } =
      this.config;
    if (!this.isLoaded) {
      return false;
    }
    const config = {
      auth: {
        clientId,
        authority,
        postLogoutRedirectUri,
        redirectUri,
      },
    };
    const userAgentApplication = new (window as any).Msal.UserAgentApplication(
      config
    );

    const account = this.account || userAgentApplication.getAllAccounts()[0];
    return !!account;
  }
}
